module.exports = __webpack_public_path__ + "media/donate/shared/trust_logos/paydirekt-9b414791afdd2adcd1598f56189c88d6.svg";